import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserService } from '../../shared/services/user.service';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';

@Component({
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})

export class RecoverPasswordComponent implements OnInit, OnDestroy {
  public loading = true;
  public hasData = false;
  public processing = false;
  public formData = {
    newPassword: '',
    newPasswordConfirm: '',
    error: '',
    message: ''
  };
  private email = '';
  private key = '';
  private queryParamsSubscription;

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const that = this;
    // Si un usuario logueado entra al la recuperación de password por URL, cierro sesión (vuelve a la home).
    if (that.authenticationService.userIsLoggedIn()) {
      this.authenticationService.logout();
    } else {
      that.queryParamsSubscription = that.route.queryParams.subscribe(params => {
        if (params && params.email && params.key) {
          that.email = params.email;
          that.key = params.key;
          that.hasData = true;
        } else {
          that.formData.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido obtener el correo para el cual se quiere reestablecer la contraseña y/o la clave de recuperación.</p>
            <p>Por favor, intente nuevamente o contacte al administrador.</p>
          `;
        }
        that.loading = false;
      });
    }
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  public recoverPassword(): void {
    const that = this;
    if (!that.processing) {
      that.processing = true;
      if (that.validatePasswords()) {
        forkJoin([
          that.userService.recoverPasswordStep2(that.email, that.key, that.formData.newPassword)
        ]).subscribe(([recoverPasswordStep2Response]) => {
            if (recoverPasswordStep2Response) {
              if (!recoverPasswordStep2Response.HasError && !recoverPasswordStep2Response.hasError) {
                that.resetFormData();
                that.formData.message = '<p><b>La contraeña ha sido cambiada con éxito.</b></p>';
              } else {
                if (recoverPasswordStep2Response.ErrorMessage){
                  that.formData.error = `<p><b>¡Error!</b></p><p>${recoverPasswordStep2Response.ErrorMessage}</p>`;
                } else {
                  that.formData.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
                }
              }
            } else {
              that.formData.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
            }
            that.processing = false;
          },
          (error) => {
            Utilities.logError('Error al solicitar la recuperación de password');
            Utilities.logError(error);
            that.processing = false;
            localStorage.clear();
            that.formData.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
          });
      } else {
        that.processing = false;
      }
    }
  }

  public validatePasswords(): boolean {
    const that = this;
    that.formData.error = '';
    that.formData.message = '';
    let dataIsValid = true;
    if (
      that.formData.newPassword &&
      that.formData.newPassword.trim().length > 0 &&
      that.formData.newPasswordConfirm &&
      that.formData.newPasswordConfirm.trim().length > 0
    ) {
      that.formData.newPassword = that.formData.newPassword.trim();
      that.formData.newPasswordConfirm = that.formData.newPasswordConfirm.trim();
      if (that.formData.newPassword !== that.formData.newPasswordConfirm) {
        dataIsValid = false;
        that.formData.error += '<p>La contraseña y la verificación deben ser iguales.</p>';
      }
      if (!dataIsValid) {
        that.formData.error = '<p><b>Por favor, solucione los errores y vuelva a intentar.</b></p>' + that.formData.error;
      }
    } else {
      dataIsValid = false;
      that.formData.error += '<p><b>Complete el formulario.</b></p><p>Todos los campos son obligatorios.</p>';
    }
    return dataIsValid;
  }

  private resetFormData(): void {
    this.formData = {
      newPassword: '',
      newPasswordConfirm: '',
      error: '',
      message: ''
    };
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
